
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/implementation",
      function () {
        return require("private-next-pages/services/implementation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/implementation"])
      });
    }
  